module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Kings_of_England"
    }
  }, [_vm._v("Kings of England in the Later Middle Ages")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Money"
    }
  }, [_vm._v("Money")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter1"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" Appearance")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter1#h1"
    }
  }, [_vm._v("Cleanliness")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter1#h2"
    }
  }, [_vm._v("Clothing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Marriage (1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2#h1"
    }
  }, [_vm._v("Age at Marriage")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2#h2"
    }
  }, [_vm._v("Weddings")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2#h3"
    }
  }, [_vm._v("Wedding Customs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2#h4"
    }
  }, [_vm._v("Present and Future Vows")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" Marriage (2)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter3#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clandestine Marriages and Bigamy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter3#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage Rights")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter3#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rank")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" Marriage (3)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter4#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Marriages")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter4#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dowry")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter4#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dower and the Courtesy of England")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Marriage (4)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter5#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abductions and Forced Marriages")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter5#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disputed and Unhappy Marriages")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter5#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Impediments and Domestic Abuse")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" Sexual Pleasure and Relationships (1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter6#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexual Pleasure and Desire")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter6#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virginity and Chastity")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 7")]), _vm._v(" Sexual Pleasure and Relationships (2)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter7#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adultery and Pre-Marital Sex")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter7#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unchaste Ecclesiastics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 8")]), _vm._v(" Love Language")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 9")]), _vm._v(" Pregnancy and Childbirth (1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter9#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Menstruation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter9#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conception and Contraception")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter9#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miscarriages and Abortions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 10")]), _vm._v(" Pregnancy and Childbirth (2)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examining Women’s Bodies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birth Aids and Customs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midwives")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multiple Births")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mortality Rates in Childbirth and Infancy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 11")]), _vm._v(" Pregnancy and Childbirth (3)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baptism and Godparents")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purification")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wet-Nurses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Size")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parents’ Ages")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 12")]), _vm._v(" Illegitimacy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 13")]), _vm._v(" Prostitution")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 14")]), _vm._v(" Ravishment and Abduction")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Age of Consent")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ravishment/Rape")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter14#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child Abuse")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 15")]), _vm._v(" Incest and Consanguinity")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 16")]), _vm._v(" Same-Sex Relationships")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 17")]), _vm._v(" Gender Roles and Expectations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transgender People")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Inequality")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Property and Female Merchants")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primogeniture and Valuing Boys")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex Ratios")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter17#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valued Women")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0